<app-header header="CART.TITLE_YOUR_ORDER"></app-header>
<div class="page" [ngClass.gt-sm]="{ 'desktop': true }">

  <div class="title" fxHide fxShow.gt-sm>

    <!-- Navigation breadcrumbs -->
    <nav id="breadcrumb">
      <ol class="breadcrumbs">
        <li class="breadcrumbs-item">
          <a [routerLink]="['..', '..']" class="breadcrumbs-link">{{ 'PRODUCT_LIST.ACTION_BREADCRUMB_TERMINALS' | translate }}</a>
        </li>
        <li class="breadcrumbs-item">
          <a [routerLink]="['..', 'packages']" class="breadcrumbs-link">{{ 'PRODUCT_LIST.TITLE_PRODUCTS_LIST' | translate }}</a>
        </li>
        <li class="breadcrumbs-item">
          <a class="breadcrumbs-link breadcrumbs-link-active">{{ 'DELIVERY_DETAILS.TITLE_DELIVERY_DETAILS' | translate }}</a>
        </li>
      </ol>
    </nav>
  </div>

  <!-- delivery details -->
  <div class="container" *ngIf="information">
    <p class="status middle">
      <mat-icon [ngStyle]="{ color:'#fcd533', 'padding-right':'6px' }">error</mat-icon>{{ information | translate }}
    </p>
  </div>
  <app-delivery-details>

    <!-- product list is projected in ng-content within the delivery-details component -->
    <h2>{{ 'CART.TITLE_YOUR_ORDER' | translate }}</h2>
    <p>{{ 'CART.TEXT_YOUR_ORDER' | translate }}</p>

    <ng-container *ngIf="{ products: products$ | async, currencyCode: buyersApiService.currencyCode$ | async } as state">
      <mat-accordion [multi]="true">
        <app-product *ngFor="let productObservable of state.products; let even = even; let odd = odd; trackBy: trackByCode;" [product$]="productObservable.observable" [locale]="locale" [currency]="state.currencyCode" [cart]="true" [expandAll$]="true$" [ngClass]="{ odd: odd, even: even }">
        </app-product>
      </mat-accordion>
      <p *ngIf="!state?.products?.length" class="status">{{ 'SEARCH.LABEL_PRODUCTS_NO_RESULTS' | translate}}</p>
    </ng-container>

  </app-delivery-details>

  <app-footer (goBack)="goBack()"></app-footer>

</div>
